import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Blog extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  constructor(props) {
    super(props)
    this.state = {
      config: props.formdata || {}
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { 
          label: 't(Previous)',
          color: 'blue',
          basic: true,
          handler: this._handleBack
        },
        { 
          label: 't(Next)',
          color: 'blue',
          handler: this._handleSubmit 
        }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Blog)',
              name: 'website_blog_strategy',
              type: 'radiogroup',
              options: [
                { value: 'yes', text: 't(Yes, I want a blog on my website)' },
                { value: 'no', text: 't(No, I do not want a blog on my website)' }
              ],
              defaultValue: config.website_blog_strategy || 'yes' 
            },
            { 
              label: 't(Recent Posts)',
              instructions: 't(Do you want to add a recent blog post section to your homepage)',
              name: 'website_blog_recent_blog_posts',
              type: 'radiogroup',
              options: [
                { value: 'yes', text: 't(Yes)' },
                { value: 'no', text: 't(No)' }
              ],
              show: config.website_blog_strategy === 'yes',
              defaultValue: config.website_blog_recent_blog_posts || 'yes' 
            },
            { 
              label: 't(Posts)',
              instructions: 't(Truevail will create up to three blog posts based on the content submitted.)',  
              name: 'website_blog_posts',
              type: 'collectionfield',
              fields: [
                { 
                  label: 't(Title)',
                  name: 'title',
                  type: 'textfield' 
                },
                { 
                  label: 't(Body)',
                  name: 'body',
                  type: 'textarea' 
                },
                { 
                  label: 't(Photos)',
                  name: 'photo_ids',
                  type: 'attachmentfield',
                  allow: { content_types: ['images'] },
                  multiple: true 
                }
              ],
              entity: 'post',
              orderable: false,
              cloneable: false,
              token: ({ value }) => (
                <div className="token">{value.title}</div>
              ),
              show: config.website_blog_strategy === 'yes',
              defaultValue: config.website_blog_posts || [] 
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(config) {
    const { formdata } = this.props
    this.props.onNext({
      ...formdata,
      ...config
    })
  }

}

export default Blog
